export default "__VITE_ASSET__BvENpfdz__"